import getColorBySpeed from "../util/color";
import { isDateInFuture, isLatterThanUpdate } from "../util/date";
import { kmhToMs } from "../util/speed";
import { TcTrackPoint } from "./type";

const cache: Record<string, TcTrackPoint[]> = {};

export default function processTcTrackArray(
  eventId: string,
  featureArray: any[],
  updateDateTime: string
): TcTrackPoint[] {
  if (cache[eventId]) {
    return cache[eventId];
  }

  // 过滤并处理轨迹点
  const pointArray = featureArray
    .filter(
      (feature) =>
        feature.geometry.type === "Point" &&
        feature.properties.Class !== "Point_Centroid"
    )
    .map((feature) => calcTrackPoint(feature, updateDateTime));

  // 使用排序函数
  const sortedPointArray = sortPointArrayByDate(pointArray);
  cache[eventId] = sortedPointArray;
  return sortedPointArray;
}

function calcTrackPoint(feature: any, updateDateTime: string): TcTrackPoint {
  // 检查入参
  if (!isValidFeature(feature)) {
    throw new Error("无效的特征对象");
  }

  // 将风速字符串转换为数字
  const windspeedRaw = feature.properties.windspeed;
  const windspeed = parseFloat(windspeedRaw);
  // const isFuture = updateDateTime
  //   ? isLatterThanUpdate(feature.properties.trackdate, updateDateTime)
  //   : isDateInFuture(feature.properties.trackdate);

  // 检查风速是否有效
  if (isNaN(windspeed)) {
    throw new Error(`风速值无效: ${windspeedRaw}`);
  }

  // 保留两位小数
  const windspeedFormatted = parseFloat(windspeed.toFixed(2));

  // 将风速从 km/h 转换为 m/s，同样保留两位小数
  const windspeedT = parseFloat(kmhToMs(windspeed).toFixed(2));

  // 构建并返回 TcTrackPoint 对象
  return {
    windspeed: windspeedFormatted,
    windspeedT: windspeedT,
    geometry: feature.geometry,
    polygonlabel: feature.properties.polygonlabel,
    trackdate: feature.properties.trackdate,
    color: getColorBySpeed(windspeedT),
    isForecast: feature.properties.isForecast
  };
}

/**
 * 按日期对轨迹点数组进行排序
 * @param pointArray 轨迹点数组
 * @returns 排序后的数组
 */
function sortPointArrayByDate(pointArray: TcTrackPoint[]): TcTrackPoint[] {
  return [...pointArray].sort((a, b) => {
    // 解析日期字符串 (DD/MM/YYYY HH:MM:SS 格式)
    const dateA = parseTrackDate(a.trackdate);
    const dateB = parseTrackDate(b.trackdate);

    // 比较日期 (升序排列 - 从早到晚)
    return dateA.getTime() - dateB.getTime();
  });
}

/**
 * 解析轨迹日期字符串为Date对象
 * @param dateStr 日期字符串 (格式: "DD/MM/YYYY HH:MM:SS")
 * @returns Date对象
 */
function parseTrackDate(dateStr: string): Date {
  if (!dateStr) {
    console.warn("无效的日期字符串");
    return new Date(0); // 返回一个最早的日期
  }

  try {
    // 将 DD/MM/YYYY 转换为 MM/DD/YYYY 以便 Date 正确解析
    const [datePart, timePart] = dateStr.split(" ");
    const [day, month, year] = datePart.split("/");
    
    return new Date(`${month}/${day}/${year} ${timePart}`);
  } catch (error) {
    console.error("日期解析错误:", error, dateStr);
    return new Date(0);
  }
}

function isValidFeature(obj: any): boolean {
  return (
    obj &&
    typeof obj === "object" &&
    obj.geometry &&
    obj.geometry.type === "Point" &&
    Array.isArray(obj.geometry.coordinates) &&
    obj.geometry.coordinates.length >= 2 &&
    obj.properties &&
    typeof obj.properties.windspeed !== "undefined"
  );
}
